import React from 'react';
import './C1.css';

const C1: React.FC = () => {
  const cards = [
    { title: 'Complex Grammar', subtitle: 'Master structure', badge: 'C1', bg: '#5EEAD4' },
    { title: 'Expression', subtitle: 'Advanced communication', badge: 'C1', bg: '#3B82F6' },
    { title: 'Academic Texts', subtitle: 'Read critically', badge: 'C1', bg: '#EF4444' },
    { title: 'Discussions', subtitle: 'Engage deeply', badge: 'C1', bg: '#9333EA' },
  ];

  return (
    <div className="level-wrapper">
      <h1 className="level-title">C1 - Advanced Level</h1>
      <div className="level-grid">
        {cards.map((card, index) => (
          <div key={index} className="level-card" style={{ backgroundColor: card.bg }}>
            <div className="level-badge">{card.badge}</div>
            <div className="level-content">
              <h2>{card.title}</h2>
              <p>{card.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default C1;
